import React, { useRef, useState } from 'react';
import { Typography } from '@mui/material';

import {
  BackdropForDialog,
  CloseButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  SubmitButton,
} from 'components';
import { ZoneCategoryForm } from 'forms';

interface ZoneCategoryUpdateDialogProps {
  visible?: boolean;
  setVisible?: (value: boolean) => void;
  title?: string;
  submitButtonLabel?: string;
  categoryId: number;
  setCategoryId: (categoryId?: number) => void;
}

export const ZoneCategoryUpdateDialog = ({
  visible = false,
  setVisible = () => {},
  title = 'Update Zone Category',
  submitButtonLabel = 'Update',
  categoryId,
  setCategoryId,
}: ZoneCategoryUpdateDialogProps) => {
  const formRef = useRef<any>();
  const [loading_form, setLoadingForm] = useState<boolean>(false);
  const [loading_submit, setLoadingSubmit] = useState<boolean>(false);

  const onClose = (event: any, reason: string) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setVisible(false);
      setCategoryId();
      document.body.removeAttribute('style');
    }
  };

  const onSubmit = () => {
    formRef.current.onSubmit();
  };

  return (
    <Dialog open={visible} onClose={onClose} PaperProps={{ sx: { overflow: 'visible' } }}>
      <DialogTitle>
        <Typography variant="h5" component="span">
          {title}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <ZoneCategoryForm
          ref={formRef}
          categoryId={categoryId}
          onInit={(loading) => setLoadingForm(loading)}
          onSubmitting={(loading) => setLoadingSubmit(loading)}
          next={() => {
            onClose(null, 'anyway');
          }}
        />
      </DialogContent>

      <DialogActions>
        <SubmitButton loading={loading_submit} label={submitButtonLabel} onClick={onSubmit} />
      </DialogActions>

      <CloseButton onClick={() => onClose(null, 'anyway')} sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }} />

      <BackdropForDialog loading={loading_form} />
    </Dialog>
  );
};
